import { render, staticRenderFns } from "./tenantSetting.vue?vue&type=template&id=43e1a776&scoped=true"
import script from "./tenantSetting.vue?vue&type=script&lang=ts"
export * from "./tenantSetting.vue?vue&type=script&lang=ts"
import style0 from "./tenantSetting.vue?vue&type=style&index=0&id=43e1a776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e1a776",
  null
  
)

export default component.exports